import React, { useState } from 'react';
import { FaMicrosoft } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import useMicrosoftLogin from '../../hooks/useMicrosoftLogin';
import './Welcome.css';
import Button from "../../components/Button/Button";
import { useForm } from "react-hook-form";
import { IoArrowBack } from "react-icons/io5";
import { login } from "../../hooks/useAuth";
import { useTranslation } from 'react-i18next';
import { fetchCurrentUser } from "../../store/user";
import { AppDispatch } from "../../store";
import { useDispatch } from "react-redux";

function Welcome() {
    const navigate = useNavigate();
    const { inProgress } = useMsal();
    const { handleAzureLogin, logout, isLoading, error, setError } = useMicrosoftLogin();

    const handleMicrosoftClick = async () => {
        const result = await handleAzureLogin();
        if (result?.success) {
            navigate('/'); // Navigate to loading page to load assets
        }
    };

    const handleDifferentAccount = async () => {
        try {
            setError(null);
            await logout();
            setTimeout(async () => {
                const result = await handleAzureLogin();
                if (result?.success) {
                    navigate('/');
                }
            }, 1000);
        } catch (error) {
            console.error('Error switching accounts:', error);
        }
    };


    const { register, handleSubmit } = useForm();
    const [errorMessage, setErrorMessage] = useState('');
    const [stayLoggedIn, setStayLoggedIn] = useState(false);
    const dispatch = useDispatch<AppDispatch>();

    const { t } = useTranslation();

    const onSubmit = async (data) => {
        try {
            await login(data.username, data.password, stayLoggedIn);
            dispatch(fetchCurrentUser());
            navigate('/loading');
        } catch (error) {
            if (error instanceof Error) {
                setErrorMessage(error.message);
            } else {
                setErrorMessage("Login failed. Please try again.");
            }
        }
    };

    return (
        <div className="welcome-container">
            <div className="welcome-element">
                <img className='welcome-img' src="/img/EnergyManager_Dark_Regular.svg" alt="Energy Manager" />
            </div>

            <div>
                <form className="form-wrapper-login login" onSubmit={handleSubmit(onSubmit)}>
                    <div className="welcome-text-wrapper">
                        <h2 className="header-login">Login</h2>
                        <p className="bread bread-text">Welcome back to Energy Manager mobile app</p>
                    </div>

                    {errorMessage && <div className="error">{errorMessage}</div>}

                    <div className="data-input-wrapper wb-1">
                        <div className="input-wrapper">
                            <input
                                type="text"
                                id="username"
                                placeholder={t('loginIndex.email.label', 'Email address')}
                                {...register('username', { required: true })}
                            />
                        </div>
                        <div className="input-wrapper">
                            <input
                                type="password"
                                id="password"
                                placeholder="Password"
                                {...register('password', { required: true })} />
                        </div>
                        <div className="input-wrapper stay-logged-in">
                            <label className="checkbox-label">
                                <input
                                    type="checkbox"
                                    checked={stayLoggedIn}
                                    onChange={(e) => setStayLoggedIn(e.target.checked)}
                                />
                                Keep me logged in
                            </label>
                        </div>
                    </div>

                    <div className="welcome-buttons">

                        <div className="login-options">
                            <div className="login-button-wrapper">
                                <Button
                                    primary={true}
                                    label="Log in"
                                    backgroundColor="var(--color-secondary)"
                                    size=""
                                />
                            </div>
                            <p className="login-subtext">or sign in with</p>

                            <button
                                className="login-btn microsoft"
                                onClick={handleMicrosoftClick}
                                disabled={isLoading || inProgress !== 'none'}
                            >
                                <FaMicrosoft style={{ marginRight: '8px' }} />
                                {isLoading || inProgress !== 'none' ? 'Signing in...' : 'Continue with Microsoft'}
                            </button>

                            {error && (
                                <div className="error-message" >
                                    {error === 'unauthorized'
                                        ? 'You are not authorized to access this application. Please contact your administrator.'
                                        : error === 'user_cancelled'
                                            ? 'Login was cancelled. Please try again.'
                                            : error === 'consent_required'
                                                ? 'Additional permissions are required. Please try again.'
                                                : error}

                                    {(error === 'unauthorized' || error === 'Session expired') && (
                                        <div style={{ marginTop: '10px' }}>
                                            <button
                                                onClick={handleDifferentAccount}
                                                style={{
                                                    backgroundColor: '#007cba',
                                                    color: 'white',
                                                    border: 'none',
                                                    padding: '8px 16px',
                                                    borderRadius: '4px',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                Try Different Account
                                            </button>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </form>

            </div>
        </div>
    );
}

export default Welcome;